module.exports = __webpack_public_path__ + "img/logo_white.e7f827c1.png";